// src/redux/reducers/industryReducer.js
import {
    FETCH_INDUSTRY_REQUEST,
    FETCH_INDUSTRY_SUCCESS,
    FETCH_INDUSTRY_FAILURE,
    SET_SELECTED_INDUSTRY,
  } from '../types';
  
  const initialState = {
    loading: false,
    industryList: [],
    selectedIndustryId: null,
    // error: '',
    error: null,
  };
  
  const industryReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_INDUSTRY_REQUEST:
        return { ...state, loading: true };
      case FETCH_INDUSTRY_SUCCESS:
        return { ...state, loading: false, industryList: action.payload };
      case FETCH_INDUSTRY_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case SET_SELECTED_INDUSTRY:
        return { ...state, selectedIndustryId: action.payload };
      default:
        return state;
    }
  };
  
  export default industryReducer;
  